import TextPreview from './TextPreview';
import CreateText from './CreateText';

const text = {
  type: 'text',
  name: 'Texts',
  icon: 'document',
  Preview: TextPreview,
  Create: CreateText
};

export default text;
